import { useEffect } from "react";

const BASE = "Drops of Honey";

// Sets document title + meta description per page for SEO (Google renders SPA JS).
export function usePageMeta(title, description) {
  useEffect(() => {
    if (title) document.title = `${title} | ${BASE}`;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
    return () => { document.title = `${BASE} — Antique Insulator Collector Catalog & Community`; };
  }, [title, description]);
}
